import {
	customShadowlessElement,
	correctElementType,
} from "@brytdesigns/web-component-core/utils";
import { FormSync } from "./components/index.js";

export type FormSyncProps = FormSync.Props;

customShadowlessElement(
	FormSync.Name,
	{
		name: "",
		formId: "",
		includedFieldNames: [],
	},
	correctElementType(FormSync.Component),
);
